<template>
  <div>
    <table class="table table-default table-hover">
      <thead>
        <tr>
          <th width="25%" class="text-nowrap">{{ $t('number') }}</th>
          <th width="25%" class="text-nowrap">{{ $t('date') }}</th>
          <th width="*" class="text-nowrap">{{ $t('amount') }}</th>
          <th width="25%" class="text-nowrap">{{ $t('cachier') }}</th>
          <th width="*" class="text-nowrap">{{ $t('verified') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invoice in invoices" @click="openPDF(invoice._id)">
          <td>{{ invoice.premise.label }}-{{ invoice.device.label }}-{{ invoice.index }}</td>
          <td>{{ invoice.issued.date | date }} {{ invoice.issued.time }}</td>
          <td>{{ invoice.services | totalAmount }}</td>
          <td>{{ invoice.cachier.name.first }} {{ invoice.cachier.name.last }}</td>
          <td>
            <i v-if="invoice.eor" class="fa fa-check-circle text-success" aria-hidden="true"></i>
            <i v-else class="fa fa-times-circle text-danger" aria-hidden="true"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <span v-if="$route.params.bookingId">
      <button v-if="invoices.length % 2" class="btn btn-danger btn-block" @click="cancelInvoice()">{{ $t('cancel') }}</button>
      <button v-else class="btn btn-primary btn-block" @click="createInvoice()">{{ $t('create') }}</button>
    </span>
    <button v-else class="btn btn-primary btn-block disabled" title="You need to create booking, before you can create invoice">{{ $t('create') }}</button>
  </div>
</template>

<script>
  const countryList = require('country-list');
  const moment = require('moment');

  export default {
    name: 'Invoices',
    data: () => ({
      invoices: [],
      booking: {
        _id: ""
      }
    }),
    filters: {
      date: function(date){
        if(!date) return '';
        return moment(date).format('DD/MM/YYYY');
      },
      totalAmount: function(services){
        let amount = 0;
        services.forEach(s => {
          amount += s.price * s.quantity;
        });
        return amount.toFixed(2);
      }
    },
    created(){
      this.booking._id = this.$route.params.bookingId;
      if(this.booking._id) this.loadInvoices();
    },
    methods: {
      openPDF: function(_id){
        window.open("/" + this.$i18n.locale + '/' + this.$t('invoices') + '/' + _id, '_blank');
      },
      loadInvoices: function(){

        let url = '/invoices?booking._id=' + this.booking._id;

        fetch(process.env.VUE_APP_API + url, {
          method: 'get',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          }
        })
        .then(response => {
          return response.json();
        })
        .then(result => {
          if(!result.error){
            return this.invoices = result;
          }
        })
      },
      createInvoice: function(){
        return this.$router.push('/' + this.$i18n.locale + '/' + this.$t('bookings') + '/' + this.$route.params.bookingId + '/' + this.$t('invoice'));
        /*fetch(process.env.VUE_APP_API + '/invoices', {
          method: 'post',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          },
          body: JSON.stringify({ booking: this.booking })
        })
        .then(response => {
          return response.json();
        })
        .then(result => {
          if(!result.error){
            return this.invoices.unshift(result);
          }
        })*/
      },
      cancelInvoice: function(){
        let invoice = this.invoices.find(invoice => (!invoice.invoice || !invoice.invoice._id) && !this.invoices.find(i => i.invoice && i.invoice._id && i.invoice._id == invoice._id))
        fetch(process.env.VUE_APP_API + '/invoices/' + invoice._id + '/cancel', {
          method: 'post',
          credentials: 'include',
          headers: {
            "Content-type": "application/json",
            "Accept": "application/json",
            "Accept-Charset": "utf-8",
            'CSRF-Token': this.$csrf
          }
        })
        .then(response => {
          return response.json();
        })
        .then(result => {
          if(!result.error){
            return this.invoices.unshift(result);
          }
        })
      }
    }
  }
</script>

<i18n>
{
  "en": {
    "bookings": "bookings",
    "invoice": "invoice",
    "invoices": "invoices",
    "number": "Invoice Number",
    "date": "Date Issued",
    "amount": "Amount",
    "cachier": "Cachier",
    "verified": "Verified",
    "create": "Create Invoice",
    "cancel": "Cancel Invoice"
  },
  "sl": {
    "bookings": "rezervacije",
    "invoice": "racun",
    "invoices": "racuni",
    "number": "Številka računa",
    "date": "Datum izdaje",
    "amount": "Znesek",
    "cachier": "Blagajnik",
    "verified": "Potrjeno",
    "create": "Ustvari račun",
    "cancel": "Storniraj račun"
  }
}
</i18n>
